import React, { Component } from 'react'

export default class Projects extends Component {
	render() {
		return (
			<div>
				<section className="colorlib-work" data-section="projects">
					<div className="colorlib-narrow-content">
						<div className="row">
							<div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
								<span className="heading-meta">My Work</span>
								<h2 className="colorlib-heading animate-box" data-animate-effect="fadeInLeft">Projects</h2>
							</div>
						</div>
						<div className="row">
							<div className="col-md-4 animate-box" data-animate-effect="fadeInLeft">
								<h3><a href="https://drive.google.com/file/d/1hgkB8FAiHphcIMiMwOUHYL2TApCla1iz/view?usp=sharing" target="_blank" rel="noopener noreferrer">My Search Engine</a></h3>
								<div className="project" style={{ backgroundImage: 'url(images/SearchEngineDemo.png)' }}>
									<div className="desc">
										<div className="con">
											<span>Java + MapReduce + AWS</span>
											<span>Our team built a distributed, large-scale, and fault-tolerant search engine inspired by Google. Completely hosted on AWS</span>
											<p className="icon">
												<span><a href="https://drive.google.com/file/d/1hgkB8FAiHphcIMiMwOUHYL2TApCla1iz/view?usp=sharing" target="_blank" rel="noopener noreferrer"><i className="icon-book" /></a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInLeft">
								<h3><a href="https://github.com/liz2020/Virtual-Live" target="_blank" rel="noopener noreferrer">Virtual-Live</a></h3>
								<div className="project" style={{ backgroundImage: 'url(images/Virtual-Live-Demo-Short.gif)' }}>
									<div className="desc">
										<div className="con">
											<span>TypeScript + Electron</span>
											<span>Virtual-Live is a desktop program that aims to enable anyone to use a webcam to control live2d characters. This program is developed for Mac, but could be compatible with Windows and Linux after some modifications.</span>
											<p className="icon">
												<span><a href="https://github.com/liz2020/Virtual-Live" target="_blank" rel="noopener noreferrer"><i className="icon-book" /></a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInLeft">
								<h3><a href="https://www.youtube.com/channel/UCaSNgcTUVjWCDrIFnofPbOg" target="_blank" rel="noopener noreferrer">Project Doko</a></h3>
								<div className="project" style={{ backgroundImage: 'url(images/doko.gif)' }}>
									<div className="desc">
										<div className="con">
											<span>ROS + ML + Dialogflow</span>
											<span>Capstone Project. Implement navigation, vision, and voice assistent on a telepresent robot </span>
											<p className="icon">
												<span><a href="https://drive.google.com/open?id=1DwCMU8PZkb20gDszPDxEk5rIIjZDvDaB" target="_blank" rel="noopener noreferrer"><i className="icon-book" /></a></span>
												<span><a href="https://www.youtube.com/channel/UCaSNgcTUVjWCDrIFnofPbOg" target="_blank" rel="noopener noreferrer"><i className="icon-youtube" /></a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInLeft">
								<h3><a href="https://github.com/liz2020/LehighMap" target="_blank" rel="noopener noreferrer">LehighMap</a></h3>
								<div className="project" style={{ backgroundImage: 'url(images/LehighMap.png)' }}>
									<div className="desc">
										<div className="con">
											<span>Android + Node.js</span>
											<span>Android App together with a Nodejs Server so that user can take a picture of buildings at Lehigh University and the CNN model will tell its name. It utilize tflite and a model trained from my own dataset.</span>
											<p className="icon">
												<span><a href="https://docs.google.com/document/d/1oVOr9hQvrv_vdq-Syg-xkYvHOELBWBJH-bYpQOVZoww/edit?usp=sharing" target="_blank" rel="noopener noreferrer"><i className="icon-book" /></a></span>
												<span><a href="https://github.com/liz2020/LehighMap" target="_blank" rel="noopener noreferrer"><i className="icon-github"></i></a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		)
	}
}
